module.exports = __webpack_public_path__ + "static/founders-3d91e0070d22e01b0ac74e0f1c7a714d.png";